import { createFileRoute, Outlet } from '@tanstack/react-router'
import shouldBeConfirmedStaff from '#app/guards/should-be-confirmed-staff'

export const Route = createFileRoute('/staff/_post-registration-required/_confirmation-required')({
  component: () => <Outlet />,

  loader: async ({ context }) => {
    await shouldBeConfirmedStaff(context)
  },
})
